import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';

export const OnDemandWebinarApi = {
    joinWebinar: (options?: BaseApiMutationOptions<ApiClient['onDemandWebinar']['joinWebinar']>) =>
        apiMutationOptions((api) => api.onDemandWebinar.joinWebinar, options)
};
